<template>
  <div id="centerRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-line" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="text mx-2">设备告警</span>
        </div>
      </div>
      <div class="d-flex jc-center body-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {
        header: [ '地址', '告警'],
        data: [
          [ '门诊4#401', "<span  class='colorGrass'>用电过载</span>"],
          [ '门诊1#112', "<span  class='colorRed'>通讯故障</span>"],
          [ '门诊1#105', "<span  class='colorGrass'>用水过载</span>"],
          [ '住院2#202', "<span  class='colorGrass'>设备故障</span>"],
          [ '住院4#405', "<span  class='colorGrass'>用气过载</span>"],
          [ '住院3#305', "<span  class='colorGrass'>水压过低</span>"],
          [ '住院6#612', "<span  class='colorGrass'>水压过高</span>"],
          [ '住院11#1108', "<span  class='colorRed'>通讯故障</span>"],
          [ '门诊5#502', "<span  class='colorRed'>设备故障</span>"],
          [ '门诊6#607', "<span  class='colorGrass'>用电过载</span>"]
        ],
        rowNum: 7, //表格行数
        headerHeight: 35,
        headerBGC: '#0f1325', //表头
        oddRowBGC: '#0f1325', //奇数行
        evenRowBGC: '#171c33', //偶数行
        index: true,
        columnWidth: [50],
        align: ['center']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$box-height: 410px;
$box-width: 300px;
#centerRight1 {
  padding: 16px;
  padding-top: 20px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
    .dv-scr-board {
      width: 270px;
      height: 340px;
    }
  }
}
</style>
